import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        repairRequests: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        repairRequestMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getRepairRequestsRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveRepairRequests", null);
            } else {
                dispatch("receivingRepairRequests"); // สถานะ กำลังบันทึก

                const formData = new FormData();
                formData.append('request_status', payload.request_status);

                axios.get('/repair_requests', {params: payload})
                    .then(function (res) {
                        dispatch("receiveRepairRequests", res.data);
                    })
                    .catch(function (e) {
                        console.log(e);
                        dispatch("receiveRepairRequests", null);
                    });

            }
        },
        loadRepairRequestRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveRepairRequest", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingRepairRequest");
                axios.get('/repair_requests/' + id).then(res => {
                    dispatch("receiveRepairRequest", res.data);
                })
            }
        },
        updateRepairRequestRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingRepairRequest");
            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('request_id', payload.request_id);
            formData.append('info_mobile', payload.info_mobile);
            formData.append('item_detail', payload.item_detail);
            formData.append('request_h_image', payload.request_h_image);
            formData.append('remarks', payload.remarks);
            formData.append('request_status', payload.request_status);
            return axios.post('/update_repair_requests', formData).then(res => {
                dispatch("updateRepairRequest", res.data);
            })

        },
        updateStatusRepairRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingRepairRequest");
            const formData = new FormData();
            formData.append('request_id', payload.request_id);
            formData.append('request_status', payload.request_status);
            formData.append('remark', payload.remark);

            return axios.post('/update_status_repair_requests', formData).then(res => {
                dispatch("updateRepairRequest", res.data);
            })


        },
        createRepairRequestRequest({dispatch}, payload) {

            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingRepairRequest");

            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('request_id', payload.request_id);
            formData.append('info_mobile', payload.info_mobile);
            formData.append('item_detail', payload.item_detail);
            formData.append('request_h_image', payload.request_h_image);
            formData.append('remarks', payload.remarks);
            formData.append('request_status', payload.request_status);
            // ✅ return Promise เพื่อให้ component ด้านบนรอได้
            return axios.post('/repair_requests', formData).then(res => {
                dispatch("receiveRepairRequest", res.data);
            });


        },
        deleteRepairRequestRequest({dispatch}, payload) {

            dispatch("afterDeleteRepairRequest", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingRepairRequest", payload);

            return axios.post('/delete_repair_requests', payload).then(res => {
                dispatch("deleteRepairRequest", {request_id: payload.request_id, res: res});
            })


        },
        receiveRepairRequests({commit}, payload) {
            commit("RECEIVED_DATAS", payload)
        },
        receivingRepairRequests({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        receiveRepairRequest({commit}, payload) {
            commit("RECEIVED_DATA", payload)
        },
        receivingRepairRequest({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        updateRepairRequest({commit}, payload) {
            commit("UPDATED_DATA", payload)
        },
        updatingRepairRequest({commit}) {
            commit("UPDATING_DATA") //  call matutions --> state.isUpdating = true;
        },
        deleteRepairRequest({commit}, payload) {
            commit("DELETED_DATA", payload)
        },
        deletingRepairRequest({commit}, payload) {
            commit("DELETING_DATA", payload)
        },
        afterDeleteRepairRequest({commit}, payload) {
            commit("AFFTER_DELETED_DATA", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_DATAS(state, payload) {
            state.repairRequests = payload;
            state.isReceiving = false;

        },
        RECEIVING_DATAS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_DATA(state, payload) {


            if (payload.request_id == undefined) {
                let error = payload.e.errorInfo == undefined ? payload.message : payload.e.errorInfo.toString()
                let repairRequestMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    repairRequestMessage: (state.repairRequestMessage == repairRequestMessage ? repairRequestMessage + ' ' : repairRequestMessage),

                });
            } else {
                let repairRequestMessage = 'บันทึกสำเร็จ! รายการ ' + payload.request_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    repairRequests: [...state.repairRequests, payload],
                    isReceiving: false,
                    errorMessage: false,
                    repairRequestMessage: (state.repairRequestMessage == repairRequestMessage ? repairRequestMessage + ' ' : repairRequestMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_DATA(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_DATA(state, payload) {
            let index = state.repairRequests.findIndex(p => p.request_id === payload.request_id);
            let repairRequestMessage = 'บันทึกสำเร็จ! รายการ ' + payload.request_id + ' ถูกแก้ไขแล้ว';

            state = Object.assign(state, {
                repairRequests: state.repairRequests.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                repairRequestMessage: (state.repairRequestMessage == repairRequestMessage ? repairRequestMessage + ' ' : repairRequestMessage),
            })
        },
        UPDATING_DATA(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_DATA(state, payload) {
            console.log(payload)


            if (payload.res.data.request_id == undefined || payload.res.data.message == 'Relation') {
                let repairRequestMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.request_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    repairRequestMessage: (state.repairRequestMessage == repairRequestMessage ? repairRequestMessage + ' ' : repairRequestMessage),

                });
            } else {
                let indexToDelete = state.repairRequests.findIndex(p => p.request_id === payload.res.data.request_id);
                let repairRequests = [...state.repairRequests];
                repairRequests.splice(indexToDelete, 1);
                let repairRequestMessage = 'บันทึกสำเร็จ! รายการ ' + payload.res.data.request_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    repairRequests: [...repairRequests],
                    isDeleting: false,
                    idToDelete: null,
                    repairRequestMessage: (state.repairRequestMessage == repairRequestMessage ? repairRequestMessage + ' ' : repairRequestMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_DATA(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.request_id;
        },
        AFFTER_DELETED_DATA(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
